declare const PermissionIDSymbol: unique symbol
export type PermissionID = string & { [PermissionIDSymbol]: never }

export interface PermissionJson {
    id: string
    name: string
}

export interface Permission {
    id: PermissionID
    name: string
}

export const createPermission = (
    params: {
        id: PermissionID
        name: string
    }
): Permission => ({
    id: params.id,
    name: params.name,
})

export const permissionFromDto = (dto: PermissionJson): Permission => (createPermission({
    id: dto.id as PermissionID,
    name: dto.name,
}))